import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm, useWatch } from "react-hook-form";
import Content from "../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../components/Component";
import { Badge, Form, Spinner } from "reactstrap";
import MyButton from "../../MyComp/UI/form/MyButton";
import Status from "../../MyComp/UI/form/Status";
import MyInput from "../../MyComp/UI/form/MyInput";
import {
  createBrandAPI,
  createProductAPI,
  listBrandAPI,
  listProductAPI,
  productByIdAPI,
  updateBrandAPI,
  updateProductAPI,
} from "../../api/master/indes";
import { decrypt, ValidateImg } from "../../utils/Utils";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import moment from "moment";
import MyCreateSelect from "../../MyComp/UI/form/MyCreateSelect";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import CKEditor from "../../MyComp/UI/CK Editor/index";
import MultiDropImage from "../../MyComp/UI/form/MultiDropImage";
import MyCheck from "../../MyComp/UI/form/MyCheck";
import {
  brandDDAPI,
  categoryDDAPI,
  diseaseDDAPI,
  ingredientsDDAPI,
  productTypeDDAPI,
  specializationDDAPI,
  unitDDAPI,
} from "../../api/dropdown";
import DropdownTreeSelect from "react-dropdown-tree-select";
import { BASE_URL_IMG, discountTypes } from "../../assets/constants";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import MyNumber from "../../MyComp/UI/form/MyNumber";
import DataTablePage from "../../pages/components/table/DataTable";
import Table from "../../MyComp/UI/DataTable/Table";
import { useLocation, useNavigate } from "react-router";
import { rainbow } from "react-syntax-highlighter/dist/esm/styles/hljs";

const AddProducts = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      loading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
      discount_type: null,
    },
  });
  const navigate = useNavigate();
  const location = useLocation();

  const mrp = useWatch({ control, name: "mrp" });
  const gst = useWatch({ control, name: "gst" });
  const offerValue = useWatch({ control, name: "offer_price" });
  const discountType = useWatch({ control, name: "discount_type" });
   const [mode, setMode] = useState(location?.state?.mode ? location?.state?.mode : "Add");
  const logout = useLogout();
  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
//   const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const loading = watch("loading");
  const [data, setData] = useState([]);
  console.log(location, "location");
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  useEffect(() => {
 if (mode === "Edit" ) {
    const body = {
      id: location?.state?.data?.id,
    };
    getProductDetails(body);
  }
    getProductType();
    getBrands();
    getUnit();
    getCategory();
    getIngredient();
    getDisease();

    // getProductList();
  }, []);
  const getProductList = () => {
    setValue("loading", true);
    listProductAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setData(res.data.data);
          resetForm();
          setValue("loading", false);
        } else if (res.data.status === false) {
          setValue("loading", false);
          setData([]);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("loading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getProductType = () => {
    productTypeDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
        //   toast.clearWaitingQueue();
          setValue("productTypeDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("productTypeDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getBrands = () => {
    brandDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("brandsDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("brandsDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getCategory = () => {
    categoryDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("categoryDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("categoryDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getUnit = () => {
    unitDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("unitDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("unitDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getDisease = () => {
    diseaseDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("diseaseDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("diseaseDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getIngredient = () => {
    ingredientsDDAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("ingredientDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("ingredientDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleImageOpenPreview = (row, name) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
// useEffect(() => {
//   if (mode === "Edit" ) {
//     const body = {
//       id: location?.state?.data?.id,
//     };
//     getProductDetails(body);
//   }
// }, [mode]);
const getProductDetails = (data) => {
//   setValue("isLoading", true);

  productByIdAPI(data)
    .then((res) => {
      if (res.data.status === true) {
        const row = res.data.data;

        // toast.clearWaitingQueue();
        window.scrollTo(0, 0);

        
  
        setIsOpen(true);
        setValue("selectedRow", row, { shouldDirty: false });
        setValue("productById", row, { shouldDirty: false });

       
        setValue("sku", row?.sku);
        setValue("mrp", row?.mrp);
        setValue("gst", row?.gst);
        setValue("hsn", row?.hsn);
        setValue("ayu_cash", row?.ayu_cash);
        setValue("offer_price", row?.offer_price);
        setValue("fragile", row?.isFragile);
        setValue("publish", row?.isPublish);
        setValue("stock", row?.total_products);
        setValue("min_purchase_qty", row?.minimum_qty);
        setValue("max_purchase_qty", row?.maximum_qty);
        setValue("low_stock_alert", row?.stock_alert);

       
        setValue("exp_date", row?.expiry_date ? new Date(row.expiry_date) : null);
        setValue("mfg_date", row?.manufacture_date ? new Date(row.manufacture_date) : null);

        
        setValue(
          "discount_type",
          discountTypes?.find((i) => i.value == row?.discount_type) || null
        );

        setValue(
          "status",
          row?.status
            ? { label: "Active", value: true }
            : { label: "InActive", value: false }
        );

        
        setValue("product_name", row?.product_name);
        setValue("product_meta_title", row?.product_meta_title);
        setValue("short_description", row?.short_description);
        setValue("long_description", row?.long_description);

        setValue("category", row?.category);
        setValue("disease", row?.disease);
        setValue("ingredients", row?.ingredient);
        setValue("brand", row?.brand);
        setValue("unit", row?.unit_data);
        setValue("product_type", row?.product_types);

        
        setValue("meta_image", row?.meta_image ? BASE_URL_IMG + row.meta_image : null);
        setValue(
          "product_banner_image",
          row?.product_banner_image ? BASE_URL_IMG + row.product_banner_image : null
        );

        
        if (row?.tags) {
          setValue(
            "meta_tags",
            row.tags.split(",").map((tag) => ({
              label: tag.trim(),
              value: tag.trim(),
            }))
          );
        }

       
        if (row?.product_gallery?.length > 0) {
          setValue(
            "product_images",
            row.product_gallery.map((item) => ({
              preview: BASE_URL_IMG + item.image,
              file: null,
            }))
          );
        }

        
        // setTimeout(() => {
        //   if (window?.CKEDITOR?.instances?.extra_product_details) {
        //     window.CKEDITOR.instances.extra_product_details.setData(
        //     //   row?.extra_product_details || ""
        //     );
        //   }
        // }, 500);

        setValue("isLoading", false);
      } 
      else if (res.data.status === "expired") {
        toast.error(res.data.message);
        logout();
      } 
      else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      setValue("isLoading", false);
      toast.error(err?.response?.data?.message);
    });
};

//   const getProductDetails = (data) => {
  
//     productByIdAPI(data)
//       .then((res) => {
      
//         //const status = decrypt(res.data.status);
//         if (res.data.status === true) {
//           toast.clearWaitingQueue();
//             if (mode == "Approval") {
//             setValue("objectionKeys", row.keys);
//           }
//   setValue("productById", res.data.data);
  
//         const row = res.data.data;
//           setValue("isLoading", false);
//           window.scrollTo(0, 0);
//           setValue("selectedRow", row);
//           setIsOpen(true);
//           setMode("Edit");
//           setValue("sku", row?.sku);
//           setValue("mrp", row?.mrp);
//           setValue("gst", row?.gst);
//           setValue("hsn", row?.hsn);
//           setValue("ayu_cash", row?.ayu_cash);
//           setValue("exp_date", new Date(row?.expiry_date));
//           setValue("mfg_date", new Date(row?.manufacture_date));
//           setValue("offer_price", row?.offer_price);
//           setValue("fragile", row?.isFragile);

//           setValue(
//             "discount_type",
//             discountTypes?.find((item) => item?.value == row?.discount_type)
//           );
//           setValue("publish", row?.isPublish);
//           setValue("stock", row?.total_products);
//           setValue("min_purchase_qty", row?.minimum_qty);
//           setValue("max_purchase_qty", row?.maximum_qty);
//           setValue("low_stock_alert", row?.stock_alert);
//           setValue("product_name", row?.product_name);
//           setValue("product_meta_title", row?.product_meta_title);
//           setValue("category", row?.category);
//           setValue("disease", row?.disease);
//           setValue("ingredients", row?.ingredient);
//           setValue("brand", row?.brand);
//           setValue("unit", row?.unit_data);
//           setValue("product_type", row?.product_types);
//           setValue("short_description", row?.short_description);
//           setValue("long_description", row?.long_description);
//           setValue("meta_image", BASE_URL_IMG + row?.meta_image);
//           setValue("product_banner_image", BASE_URL_IMG + row?.product_banner_image);
//           setValue("status", row?.status ? { label: "Active", value: true } : { label: "InActive", value: false });
//           if (row?.tags) {
//             const tagArray = row.tags.split(",").map((tag) => {
//               const trimmed = tag.trim();
//               return {
//                 label: trimmed,
//                 value: trimmed,
//               };
//             });

//             setValue("meta_tags", tagArray);
//           }
//           if (row?.product_gallery?.length > 0) {
//             const images = row.product_gallery.map((item) => ({
//               preview: BASE_URL_IMG + item?.image,
//               file: null,
//             }));

//             setValue("product_images", images);
//           }
//           setTimeout(() => {
//             if (window?.CKEDITOR?.instances?.extra_product_details) {
//               window.CKEDITOR.instances.extra_product_details.setData(row?.extra_product_details || ""); // Set existing content
//             }
//           }, 500);

//           setValue("isLoading", false);
//         } else if (res.data.status === false) {
//           setValue("isLoading", false);
//           setValue("productById", []);
//           toast.error(res.data.message);
//           toast.clearWaitingQueue();
//         } else if (res.data.status === "expired") {
//           setValue("isLoading", false);
//           toast.error(res.data.message);
//           toast.clearWaitingQueue();
//           logout();
//         }
//       })
//       .catch((err) => {
//         setValue("isLoading", false);
//         toast.error(err?.response?.data?.message);
//       });
//   };
  const resetForm = () => {
    setMode("Add");
    setValue("sku", "");
    setValue("mrp", "");
    setValue("gst", "");
    setValue("hsn", "");
    setValue("ayu_cash", "");
    setValue("exp_date", null);
    setValue("mfg_date", null);
    setValue("offer_price", "");
    setValue("fragile", "");
    setValue("publish", "");
    setValue("stock", "");
    setValue("min_purchase_qty", "");
    setValue("max_purchase_qty", "");
    setValue("low_stock_alert", "");
    setValue("product_name", "");
    setValue("product_meta_title", "");
    setValue("category", "");
    setValue("disease", "");
    setValue("ingredients", "");
    setValue("brand", "");
    setValue("unit", "");
    setValue("product_type", "");
    setValue("short_description", "");
    setValue("long_description", "");
    setValue("meta_image", null);
    setValue("product_banner_image", null);
    setValue("status", "");
    setValue("meta_tags", "");
    setValue("product_images", null);
    setValue("isPub", false);
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("sku", row?.sku);
    setValue("mrp", row?.mrp);
    setValue("gst", row?.gst);
    setValue("hsn", row?.hsn);
    setValue("ayu_cash", row?.ayu_cash);
    setValue("exp_date", new Date(row?.expiry_date));
    setValue("mfg_date", new Date(row?.manufacture_date));
    setValue("offer_price", row?.offer_price);
    setValue("fragile", row?.isFragile);

    setValue(
      "discount_type",
      discountTypes?.find((item) => item?.value == row?.discount_type)
    );
    setValue("publish", row?.isPublish);
    setValue("stock", row?.total_products);
    setValue("min_purchase_qty", row?.minimum_qty);
    setValue("max_purchase_qty", row?.maximum_qty);
    setValue("low_stock_alert", row?.stock_alert);
    setValue("product_name", row?.product_name);
    setValue("product_meta_title", row?.product_meta_title);
    setValue("category", row?.category);
    setValue("disease", row?.disease);
    setValue("ingredients", row?.ingredient);
    setValue("brand", row?.brand);
    setValue("unit", row?.unit_data);
    setValue("product_type", row?.product_types);
    setValue("short_description", row?.short_description);
    setValue("long_description", row?.long_description);
    setValue("meta_image", BASE_URL_IMG + row?.meta_image);
    setValue("product_banner_image", BASE_URL_IMG + row?.product_banner_image);
    setValue("status", row?.status ? { label: "Active", value: true } : { label: "InActive", value: false });
    if (row?.tags) {
      const tagArray = row.tags.split(",").map((tag) => {
        const trimmed = tag.trim();
        return {
          label: trimmed,
          value: trimmed,
        };
      });

      setValue("meta_tags", tagArray);
    }
    if (row?.product_gallery?.length > 0) {
      const images = row.product_gallery.map((item) => ({
        preview: BASE_URL_IMG + item?.image,
        file: null,
      }));

      setValue("product_images", images);
    }
    setTimeout(() => {
      if (window?.CKEDITOR?.instances?.extra_product_details) {
        window.CKEDITOR.instances.extra_product_details.setData(row?.extra_product_details || ""); // Set existing content
      }
    }, 500);
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    const extra_product_description = window?.CKEDITOR?.instances.extra_product_details?.getData();
    const cleanedContent = extra_product_description.replace(/&nbsp;/g, " ");
    formData.append("product_name", watch("product_name"));
    formData.append("product_meta_title", watch("product_meta_title"));
    formData.append("mrp", watch("mrp"));
    formData.append("offer_price", watch("offer_price"));
    formData.append("extra_product_description", cleanedContent);
    formData.append("ayu_cash", watch("ayu_cash"));
    formData.append("final_price", watch("final_price"));
    formData.append("product_type", watch("product_type")?.value);
    formData.append("brand", watch("brand")?.value);
    formData.append("discount_type", watch("discount_type")?.value);
    formData.append("category", watch("category")?.value);
    formData.append(
      "disease",
      watch("disease")?.map((item) => item.value)
    );
    formData.append("exp_date", moment(watch("exp_date")).format("YYYY-MM-DD"));
    formData.append("mfg_date", moment(watch("mfg_date")).format("YYYY-MM-DD"));
    formData.append("fragile", watch("fragile"));
    formData.append("gst", watch("gst"));
    formData.append("hsn", watch("hsn"));
    formData.append("sku", watch("sku"));
    formData.append("stock", watch("stock"));
    formData.append("publish", watch("publish"));
    formData.append("unit", watch("unit")?.value);
    formData.append("status", watch("status")?.value);
    formData.append("max_purchase_qty", watch("max_purchase_qty"));
    formData.append("min_purchase_qty", watch("min_purchase_qty"));
    formData.append("low_stock_alert", watch("low_stock_alert"));
    formData.append("long_description", watch("long_description"));
    formData.append("short_description", watch("short_description"));
    formData.append(
      "ingredients",
      watch("ingredients")?.map((item) => item.value)
    );
    formData.append(
      "meta_tags",
      watch("meta_tags")?.map((item) => item.value)
    );
    // formData.append("meta_img", watch("meta_img"));
    // formData.append("product_banner_img", watch("product_banner_img"));
    // const files = data.product_images;
    // if (files && files.length > 0) {
    //   files.forEach((file, index) => {
    //     // file is already a File object with path and preview
    //     formData.append("product_images", file); // or use `images[]` depending on backend
    //   });
    // }
    const metaImg = watch("meta_img");
    const productBannerImg = watch("product_banner_img");

    if (metaImg instanceof File) {
      formData.append("meta_img", metaImg);
    } else if (typeof metaImg === "string") {
      formData.append("meta_img", metaImg);
    }
    if (productBannerImg instanceof File) {
      formData.append("product_banner_img", productBannerImg);
    } else if (typeof productBannerImg === "string") {
      formData.append("product_banner_img", productBannerImg);
    }
    const files = data.product_images;
    if (files && files.length > 0) {
      files.forEach((item, index) => {
        if (item instanceof File) {
          formData.append("product_images", item);
        } else if (typeof item.preview === "string") {
          const fileName = item.preview.split("/").pop();
          formData.append("product_images", fileName);
        }
      });
    }
    console.log("data", data);
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }
    if (mode == "Add") {
      createProductAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setIsOpen(false);
            getProductList();
            setValue("isLoading", false);
            resetForm();
            navigate("/master/product");
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateProductAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            setIsOpen(false);
            getProductList();
            setValue("isLoading", false);
            resetForm();
            navigate("/master/product");
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();

            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }

    console.log("form data", data);
  };

  const handleChange = (currentNode, selectedNodes) => {
    console.log("Selected nodes:", selectedNodes);
    const selectedIds = selectedNodes.map((node) => node.id);
    console.log("Selected IDs:", selectedIds);
  };
  const confirmStatusChange = (data) => {
    const formData = new FormData();
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    const updatedPub = watch("selectedRow").isPublish === true ? false : true;
    if (watch("isPub")) {
      formData.append("publish", updatedPub);
    } else {
      formData.append("status", updatedStatus);
    }
    formData.append("id", watch("selectedRow")?.id);
    setValue("isLoading", true);
    updateProductAPI(formData)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getProductList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
          resetForm();
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  function flattenOptions(options, path = []) {
    return options.flatMap((opt) => {
      const fullPath = [...path, opt.label];
      const flatOption = {
        label: fullPath.join(" → "),
        value: opt.value,
      };
      return opt.children ? [flatOption, ...flattenOptions(opt.children, fullPath)] : [flatOption];
    });
  }
  //   function flattenOptions(options, depth = 0) {
  //   return options.flatMap(opt => {
  //     const prefix = '-'.repeat(depth);
  //     const flatOption = {
  //       label: `${prefix} ${opt.label}`,
  //       value: opt.value,
  //     };
  //     return opt.children
  //       ? [flatOption, ...flattenOptions(opt.children, depth + 1)]
  //       : [flatOption];
  //   });
  // }

  // 3. Flattened options for react-select
  const flatOptions = flattenOptions(watch("categoryDD"));
  useEffect(() => {
    // setValue("offer_price", "");
  }, [watch("discount_type")]);

  useEffect(() => {
    const mrpVal = parseFloat(mrp) || 0;
    const gstVal = parseFloat(gst) || 0;
    const offerVal = parseFloat(offerValue) || 0;
    const discount = discountType?.value;

    let discountAmount = 0;
    let discountedPrice = mrpVal;

    if (discount === "flat") {
      // Ensure flat discount doesn't exceed MRP
      discountAmount = offerVal > mrpVal ? mrpVal : offerVal;
      discountedPrice = mrpVal - discountAmount;
    } else if (discount === "percentage") {
      // Percentage should not be more than 100%
      discountAmount = (mrpVal * offerVal) / 100;
      discountedPrice = mrpVal - discountAmount;
    }

    // Prevent discounted price from going below zero
    discountedPrice = discountedPrice < 0 ? 0 : discountedPrice;

    // GST calculated on discounted price
    const gstAmount = (discountedPrice * gstVal) / 100;
    const finalPrice = discountedPrice + gstAmount;

    setValue("final_price", Math.round(finalPrice * 100) / 100, { shouldValidate: true });
    trigger("final_price");
  }, [mrp, gst, offerValue, discountType, setValue, trigger]);

  console.log("final price", watch("final_price"));
  return (
    <>
      <Head title={"Add Product | Master"} />
      <Content style={{ margin: "500px" }}>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Add Products"}
              </BlockTitle>
            </BlockHeadContent>
            {location?.state == null ? null : (
              <BlockHeadContent>
                <div className="">
                  <Button
                    color="primary"
                    outline
                    className={`  me-n1`}
                    onClick={() => {
                      navigate("/master/product");
                    }}
                  >
                    <Icon name={"arrow-left"} />
                  </Button>
                </div>
              </BlockHeadContent>
            )}
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard className="mb-5" style={{ padding: "50px" }}>
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row>
                <Col md="6" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Product Name"}
                    name={"product_name"}
                    placeholder={"Enter product name"}
                    required
                    min={2}
                    max={50}
                  />
                </Col>
                <Col md="6" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Product Meta Title"}
                    name={"product_meta_title"}
                    placeholder={"Enter product meta title"}
                    required
                    min={40}
                    max={120}
                  />
                </Col>
                <Col md={2}>
                  <MyCheck
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Fragile"}
                    name={"fragile"}
                    placeholder={"Is Product Fragile"}
                  />
                </Col>

                <Col md="2" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Product Type"}
                    name={"product_type"}
                    placeholder={"Select product type"}
                    required
                    options={watch("productTypeDD")}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Brand"}
                    name={"brand"}
                    placeholder={"Select brand"}
                    required
                    options={watch("brandsDD")}
                  />
                </Col>
                <Col md="2" className={``}>
                  {/* <DropdownTreeSelect data={op} onChange={handleChange} /> */}
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Category"}
                    name={"category"}
                    placeholder={"Select category"}
                    required
                    options={flatOptions}
                  />
                </Col>

                <Col md="2" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Size/Weight"}
                    name={"unit"}
                    placeholder={"Select size / weight"}
                    required
                    options={watch("unitDD")}
                  />
                </Col>

                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Stock"}
                    name={"stock"}
                    placeholder={"Enter available stock"}
                    required
                    min={1}
                    max={4}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Low Stock Alert Qty"}
                    name={"low_stock_alert"}
                    placeholder={"Enter low stock alert qty"}
                    required
                    min={1}
                    max={2}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyNumber
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Minimum purchase qty"}
                    name={"min_purchase_qty"}
                    placeholder={"Enter minimum purchase qty"}
                    required
                    min={1}
                    max={99}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyNumber
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Maximum purchase qty"}
                    name={"max_purchase_qty"}
                    placeholder={"Enter maximum purchase qty"}
                    required
                    min={1}
                    max={99}
                  />
                </Col>

                <Col md="2" className={``}>
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Manufacturing Date"}
                    name={"mfg_date"}
                    placeholder={"Enter manufacturing date"}
                    required
                    max={new Date()}
                    min={moment().subtract(2, "years").toDate()}
                     control={control}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Expiry Date"}
                    name={"exp_date"}
                    placeholder={"Enter expiry date"}
                    required
                    min={moment().add(1, "days").toDate()}
                    max={moment().add(5, "years").toDate()}
                     control={control}
                  />
                </Col>

                <Col md="2" className={``}>
                  <MyNumber
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"MRP"}
                    name={"mrp"}
                    placeholder={"Enter MRP"}
                    required
                    min={1}
                    max={9999}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Discount Type"}
                    name={"discount_type"}
                    placeholder={"Select discount type"}
                    options={discountTypes}
                  />
                </Col>
                {watch("discount_type") != null && (
                  <Col md="2" className={``}>
                    <MyNumber
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={watch("discount_type")?.value == "flat" ? "Discount Price" : "Discount Percent"}
                      name={"offer_price"}
                      placeholder={
                        watch("discount_type")?.value == "flat" ? "Enter discount price" : "Enter discount percent"
                      }
                      required
                      min={1}
                      max={watch("discount_type")?.value == "flat" ? 999 : 99}
                    />
                  </Col>
                )}
                <Col md="2" className={``}>
                  <MyNumber
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"GST"}
                    name={"gst"}
                    placeholder={"Enter gst %"}
                    required
                    min={1}
                    max={50}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Final Price"}
                    name={"final_price"}
                    placeholder={"Final price"}
                    disabled
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyNumber
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"AYU Cash"}
                    name={"ayu_cash"}
                    placeholder={"Enter ayu cash"}
                    required
                    min={1}
                    max={500}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"HSN"}
                    name={"hsn"}
                    placeholder={"Enter hns name"}
                    required
                    min={2}
                    max={50}
                  />
                </Col>
                <Col md="2" className={``}>
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"SKU"}
                    name={"sku"}
                    placeholder={"Enter sku name"}
                    required
                    min={2}
                    max={50}
                  />
                </Col>
                <Col md="6" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Ingredients"}
                    name={"ingredients"}
                    placeholder={"Select ingredients"}
                    required
                    options={watch("ingredientDD")}
                    multi
                  />
                </Col>

                <Col md="6" className={``}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Disease"}
                    name={"disease"}
                    placeholder={"Select disease"}
                    required
                    options={watch("diseaseDD")}
                    multi
                  />
                </Col>
                <Col md="6" className={``}>
                  <MyCreateSelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Meta Tags"}
                    name={"meta_tags"}
                    placeholder={"Create meta tags"}
                    required
                    multi
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    id="meta_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Meta Image"}
                    errors={errors}
                    register={register}
                    image={"meta_img"}
                    image_url={"meta_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    getValues={getValues}
                  />
                </Col>
                <Col md={3}>
                  <ImageUpload
                    id="product_banner_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Product Banner Image"}
                    errors={errors}
                    register={register}
                    image={"product_banner_img"}
                    image_url={"product_banner_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    getValues={getValues}
                  />
                </Col>
                <Col md={12}>
                  <MultiDropImage
                    name={"product_images"}
                    title={"Product Images"}
                    register={register}
                    setValue={setValue}
                    watch={watch}
                    trigger={trigger}
                    errors={errors}
                    fileType={[".jpg", ".png", ".svg"]}
                    maxSize={1024}
                    required
                  />
                </Col>
                <Col md="12" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Short Description"}
                    name={"short_description"}
                    placeholder={"Enter short product description"}
                    required
                    min={25}
                    max={300}
                    cols={2}
                    row={2}
                  />
                </Col>
                <Col md="12" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Long Description"}
                    name={"long_description"}
                    placeholder={"Enter long product description"}
                    required
                    min={100}
                    max={500}
                    cols={2}
                    row={2}
                  />
                </Col>
                <Col md={12}>
                  <CKEditor title={"Extra Product Details"} id="extra_product_details" />
                </Col>

                <Col md={`2`}>
                  <Status register={register} watch={watch} setValue={setValue} trigger={trigger} errors={errors} />
                </Col>
                <Col md={2}>
                  <MyCheck
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Publish"}
                    name={"publish"}
                    placeholder={"Is Product Ready to go live"}
                  />
                </Col>
              </Row>
              <Col md="2" className={``}>
                <div className="form-group" style={{ marginTop: "31px" }}>
                  <MyButton
                    onClick={() => {
                      navigate("/master/product", { state: { mode: "Add" } });
                    }}
                    isLoading={isLoading}
                    mode={location.state.mode}
                  />
                </div>
              </Col>
            </Form>
          </PreviewAltCard>

          {/* <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={loading} /> */}
        </Block>
      </Content>
    </>
  );
};

export default AddProducts;
